import React from 'react';
import AppTemplate from 'components/base/template/AppTemplate';
import AppNav from 'components/base/nav/AppNav';
import { Route, Redirect, Switch } from 'react-router-dom';
import InvoiceContainer from 'containers/invoice/InvoiceContainer';
import { pageUrl } from 'lib/mapper';

function Invoice() {
  return (
    <AppTemplate
      title={'Invoice'}
      leftSide={<AppNav />}
      mainStyle={{
        padding: '0 0 0 40px',
      }}
    >
      <Switch>
        <Route exact path={pageUrl.invoice.index} component={InvoiceContainer} />
        <Route component={() => <Redirect to={pageUrl.error.notFound} />} />
      </Switch>
    </AppTemplate>
  );
}

export default Invoice;
